import { render, staticRenderFns } from "./QScoreCards_QuilityRx.vue?vue&type=template&id=21dfd0ce&scoped=true&"
import script from "./QScoreCards_QuilityRx.vue?vue&type=script&lang=js&"
export * from "./QScoreCards_QuilityRx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dfd0ce",
  null
  
)

export default component.exports